export class SkipOrderType {
  id: number;
  name: string;
  createdAt: string;
  updatedAt: string;
}
